/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpServersListForOrg } from "../funcs/mcpServersListForOrg.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMcpServersResult } from "../models/components/listmcpserversresult.js";
import {
  ListMcpServersForOrgRequest,
  ListMcpServersForOrgSecurity,
} from "../models/operations/listmcpserversfororg.js";
import { unwrapAsync } from "../types/fp.js";
export type ListMcpServersForOrgQueryData = ListMcpServersResult;

export function prefetchListMcpServersForOrg(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMcpServersForOrgRequest | undefined,
  security?: ListMcpServersForOrgSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListMcpServersForOrgQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListMcpServersForOrgQuery(
  client$: GramCore,
  request?: ListMcpServersForOrgRequest | undefined,
  security?: ListMcpServersForOrgSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListMcpServersForOrgQueryData>;
} {
  return {
    queryKey: queryKeyListMcpServersForOrg({
      gramSession: request?.gramSession,
    }),
    queryFn: async function listMcpServersForOrgQueryFn(
      ctx,
    ): Promise<ListMcpServersForOrgQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpServersListForOrg(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListMcpServersForOrg(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "mcpServers", "listForOrg", parameters];
}
